/* istanbul ignore file */
import { DEFAULT_ENTITY_AUTHOR } from 'domain/shared/core/constants';
import { EntityHeader } from 'framework/ui/layout';

const OpportunityEntityHeader = () => {
  return <EntityHeader entityTitleSource="name" defaultAuthor={DEFAULT_ENTITY_AUTHOR} color="textPrimary" />;
};

export default OpportunityEntityHeader;
